"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports["default"] = void 0;
var _types = require("../../actions/ReadinessCheck/types");
var _ReadinessCheck = require("@studio/constants/ReadinessCheck");
var _utils = require("../../actions/ReadinessCheck/utils");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var initialState = exports.initialState = {
  speaker: _ReadinessCheck.CHECKING,
  camera: _ReadinessCheck.CHECKING,
  microphone: _ReadinessCheck.CHECKING,
  connectivity: _ReadinessCheck.CHECKING,
  screenShare: _ReadinessCheck.WAITING,
  device: (0, _utils.isMobileDevice)() ? _ReadinessCheck.FAILED : _ReadinessCheck.PASSED,
  browser: (0, _utils.isChromiumBased)() ? _ReadinessCheck.PASSED : _ReadinessCheck.FAILED,
  proxyType: _ReadinessCheck.NO_PROXY_SERVER
};
function readinessCheck() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (action.type === _types.BROADCAST_SET_READINESS_CHECK) {
    var newState = _objectSpread(_objectSpread({}, state), action.payload);
    return newState;
  }
  if (action.type === "".concat(_types.BROADCAST_RUN_READINESS_CHECK, "_SUCCESS")) {
    return _objectSpread(_objectSpread({}, state), action.payload);
  }
  return state;
}
var _default = exports["default"] = readinessCheck;